// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"GalleryPhotoSocial-styles__wrapper__L6tu8","icon":"GalleryPhotoSocial-styles__icon__V2U1D"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/gallery/components/GalleryPhotoSocial-styles.scss
// module id = 1042
// module chunks = 4 22 26 29